// extracted by mini-css-extract-plugin
module.exports = {"container":"_2UE-H1tHzJDFsSG9UOloJi","groupsList":"_2fFbyBLlOOxIeOBh_fBuRA"};